import { render, staticRenderFns } from "./Connections.vue?vue&type=template&id=2fc33ec0&scoped=true&"
import script from "./Connections.vue?vue&type=script&lang=js&"
export * from "./Connections.vue?vue&type=script&lang=js&"
import style0 from "./Connections.vue?vue&type=style&index=0&id=2fc33ec0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc33ec0",
  null
  
)

export default component.exports